import type { MutationResult } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type { PageResult } from '../../shared/data/types';
import type {
  ChangeWithdrawalControlStatusInput,
  CreateWithdrawalPolicyInput,
  PartnerWithdrawalPolicy,
  PartnerWithdrawalVelocityRule,
  UpdateWithdrawalPolicyInput,
  WithdrawalPolicyListQuery,
  WithdrawalVelocityListQuery,
} from './types';

export interface WithdrawalControlsRepository {
  listPolicies(
    partnerId: string,
    query: WithdrawalPolicyListQuery,
    signal: AbortSignal,
  ): Promise<PageResult<PartnerWithdrawalPolicy>>;
  createPolicy(
    partnerId: string,
    input: CreateWithdrawalPolicyInput,
  ): Promise<MutationResult<PartnerWithdrawalPolicy>>;
  getPolicy(
    partnerId: string,
    policyId: string,
    signal: AbortSignal,
  ): Promise<PartnerWithdrawalPolicy>;
  updatePolicy(
    partnerId: string,
    policyId: string,
    input: UpdateWithdrawalPolicyInput,
  ): Promise<MutationResult<PartnerWithdrawalPolicy>>;
  changePolicyStatus(
    partnerId: string,
    policyId: string,
    input: ChangeWithdrawalControlStatusInput,
  ): Promise<MutationResult<PartnerWithdrawalPolicy>>;
  listVelocityRules(
    partnerId: string,
    query: WithdrawalVelocityListQuery,
    signal: AbortSignal,
  ): Promise<PageResult<PartnerWithdrawalVelocityRule>>;
  getVelocityRule(
    partnerId: string,
    ruleId: string,
    signal: AbortSignal,
  ): Promise<PartnerWithdrawalVelocityRule>;
}

export const withdrawalControlsRepositoryToken =
  createRepositoryToken<WithdrawalControlsRepository>('withdrawalControls');

export const defaultWithdrawalPolicyQuery = Object.freeze<WithdrawalPolicyListQuery>({
  page: 1,
  pageSize: 25,
  filters: { status: '', currencyCode: '' },
});

export const defaultWithdrawalVelocityQuery = Object.freeze<WithdrawalVelocityListQuery>({
  page: 1,
  pageSize: 25,
  filters: { status: '', currencyCode: '', dimension: '' },
});
